<template>
  <div>
    <div style="font-size: 15px!important;">
      {{ $t('base.product_campaign_detail') }} - Campaign ID:
      <strong style="font-size: 15px; cursor: pointer" class="text-danger"
              @click="copy_text(campaign && campaign.campaign ? campaign.campaign.campaignid : '' )">
        {{ campaign && campaign.campaign && campaign.campaign.campaignid }}
      </strong>
      - Product ID:
      <strong style="font-size: 15px; cursor: pointer" class="text-danger"
              @click="copy_text(campaign && campaign.product ? campaign.product.itemid : '' )">
        {{ campaign && campaign.product && campaign.product.itemid }}
      </strong>
    </div>
    <div style="font-size: 15px!important; margin-top: 10px">
      {{ $t('base.keyword') }}:
      <strong style="font-size: 17px; cursor: pointer" class="text-danger"
              @click="copy_text(keyword ? keyword.keyword : '')">
        {{ keyword ? keyword.keyword : '' }}
      </strong>
    </div>

    <div style="margin-top: 40px; display: flex; gap: 10px">
      <el-date-picker
        v-model="date_range" type="daterange" range-separator="-"
        style="width: 400px"
        :start-placeholder="$t('base.start_time')" :end-placeholder="$t('base.end_time')" size="mini"
        format="dd-MM-yyyy" :clearable="false"
        :picker-options="picker_options">
      </el-date-picker>
      <el-button type="primary" size="mini" icon="el-icon-search" :loading="loading.get_data"
                 @click="m__get_metrics()">{{ $t('base.analyze') }}
      </el-button>
    </div>

    <div style="margin-top: 30px">
      <div style="font-size: 12px; font-weight: 500">
        {{ $t('base.selected') }} {{ flag_list.filter(i => i.checked).length }}/{{ max_selected_metrics }}
        {{ $t('base.metrics') }}
      </div>
      <div style="margin-top: 10px; border: 1px solid #e5e5e5;border-radius: 4px; padding: 20px 10px 10px 10px">
        <div v-for="flag in flag_list" :key="flag.value"
             style="width: 20%; float: left; margin-bottom: 10px; font-size: 13px">
          <el-checkbox size="mini" v-model="flag.checked" @change="flag.checked = $event; m__get_metrics()"
                       class="cbx-black"
                       :disabled="(flag.checked === true && flag_list.filter(i => i.checked).length <= 1) || (!flag.checked && flag_list.filter(i => i.checked).length >= max_selected_metrics)">
            &nbsp;{{ flag.label }}
          </el-checkbox>
        </div>
        <div style="clear: both!important;"></div>
      </div>
    </div>

    <div style="margin-top: 40px; display: flex">
      <div style="flex: 1">
        <el-button v-if="view_type === 'chart'" type="text" size="mini" @click="view_type = 'table'">
          <strong class="text-primary">{{ $t('base.table') }}</strong>
        </el-button>
        <el-button v-if="view_type === 'table'" type="text" size="mini" @click="view_type = 'chart'">
          <strong class="text-primary">{{ $t('base.chart') }}</strong>
        </el-button>
      </div>
      <div style="flex: 1; text-align: right">
        <template v-for="key in Object.keys(key_list)">
          &nbsp;&nbsp;&nbsp;
          <span class="circle" :style="`background-color: ${key_list[key].color}`"></span>
          <span style="font-size: 13px">{{ key_list[key].name }}</span>
        </template>
      </div>
    </div>

    <div style="margin: 20px 0">
      <div v-if="view_type === 'chart'">
        <KeywordMetricsLineChart style="margin-top: 5px; height: 220px; width: 100%" :reports="reports"
                                 :key_list="key_list" :selected_key_list="selected_key_list">
        </KeywordMetricsLineChart>
      </div>
      <div v-if="view_type === 'table'">
        <el-table :data="reports">
          <el-table-column prop="timestamp" :label="$t('base.time')" width="150px">
            <template slot-scope="scope">
              {{ scope.row.timestamp * 1000 |moment('DD-MM-YYYY') }}
            </template>
          </el-table-column>
          <template v-for="key in Object.keys(key_list)">
            <el-table-column :label="key_list[key].name" :prop="'metrics.' + key" width="300px" sortable>
              <template slot-scope="scope">
                {{ scope.row.metrics[key] | currency }} {{ percent_list.includes(key) ? '%' : '' }}
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import {base_flag, picker_options} from "../../../addon/options"
import KeywordMetricsLineChart from "./keyword_metrics_line_chartjs.js"

export default {
  name: 'component__keyword_metrics',

  props: {
    shop: {},
    campaign: {},
    keyword: null,
    keyword_metrics: false
  },

  components: {
    KeywordMetricsLineChart
  },

  data() {
    return {
      flag_list: [],
      date_range: [this.dayjs().subtract(1, 'week').toDate(), new Date()],
      picker_options: picker_options,
      loading: {
        get_data: false
      },
      default_checked_list: ['impression', 'click', 'broad_gmv', 'broad_cir'],
      max_selected_metrics: 8,
      reports: [],
      key_list: {},
      selected_key_list: [],
      color: [
        'rgb(54, 127, 227)',
        'rgb(246, 189, 22)',
        'rgb(35, 170, 171)',
        'rgb(88, 183, 241)',
        'rgb(251, 115, 75)',
        'rgb(148, 95, 185)',
        'rgb(215,81,82)',
        'rgb(105,39,255)',
      ],
      view_type: 'chart',
      reduce_100k_list: ['broad_gmv', 'direct_gmv', 'cost', 'cpc', 'cpdc'],
      percent_list: ['broad_cir', 'direct_cir', 'ctr', 'broad_cr', 'direct_cr']
    }
  },

  beforeMount() {
    for (const flag of this.clone(base_flag)) {
      flag.checked = this.default_checked_list.includes(flag.value);
      this.flag_list.push(flag)
    }
  },

  watch: {
    'keyword_metrics': function () {
      if (this.keyword_metrics) {
        this.m__get_metrics()
      }
    }
  },

  methods: {
    async m__get_metrics() {
      this.reports = []
      this.key_list = {}
      this.selected_key_list = []

      this.loading.get_data = true;

      try {
        const form = {
          shop_id: this.shop._id,
          campaign_id: this.campaign.campaign.campaignid,
          keyword: this.keyword.keyword,
          start_time: this.dayjs(this.date_range[0]).unix(),
          end_time: this.dayjs(this.date_range[1]).unix(),
          metric_list: this.flag_list.filter(i => i.checked).map(i => i.value)
        };

        const response = await this.$http.post(this.API.URL_API_SRV_2 + '/mipee/shopee_ads/get_metrics_by_keyword', form, this.cf())

        for (const item of response.body.data) {
          item.timestamp = item.unix
          for (const key of Object.keys(item.metrics)) {
            if (this.reduce_100k_list.includes(key)) {
              item.metrics[key] = item.metrics[key] / 100000
            }

            if (this.percent_list.includes(key)) {
              item.metrics[key] = item.metrics[key] * 100
            }
          }
        }

        for (const [index, flag] of this.flag_list.filter(i => i.checked).entries()) {
          this.key_list[flag.value] = {
            name: flag.label,
            color: this.color[index]
          }
          this.selected_key_list.push(flag.value)
        }

        console.log('response.body.data', response.body.data)
        this.reports = response.body.data
      } catch (e) {
        console.error(e)
      } finally {
        this.loading.get_data = false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/pas/component/component_keyword_metrics.vue